<div class="unit-details-container h-100">
  <app-dashboard-container
    [isLoading]="isLoading$ | async"
    [containerCss]="'no-separator h-100'"
    [isEmptyDashboard]="false"
    [customEmptyDashboardTemplate]="unitEmptyDataTemplate"
  >
    <div header class="header-container">
      <app-dashboard-user-header
        [customHeaderTemplate]="customHeaderTemplate"
        [containerCss]="'turnover-form'"
      ></app-dashboard-user-header>
    </div>
    <div body>
      <form [formGroup]="form" *ngIf="form" class="details-section display-flex flex-column">
        <div class="section-item">
          <div *ngIf="!readOnly" class="label-caps">unit details</div>
          <div class="section-item-content">
            <app-input
              *ngIf="unit.isNonPms"
              class="unit-name"
              [labelCss]="'nowrap pre-label'"
              [containerCss]="'display-flex flex-column grid-gap-4'"
              [attrPlaceholder]="'Unit name...'"
              [formControl]="nameControl"
              [attrLabel]="'Name'"
              [errorSection]="false"
            ></app-input>
            <mat-checkbox
              *ngIf="unit"
              color="primary"
              [ngModel]="doNotAutoCreateTurns"
              (ngModelChange)="changeDoNotAutoCreateTurns($event)"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isUnitDoNotAutoCreateTurnsLoading$ | async"
              matTooltipPosition="below"
              matTooltip="Non-revenue, waitlist, model, burn, holding, weird vibes"
            >
              Do not auto create turns for this unit
            </mat-checkbox>
          </div>
        </div>
        <div class="section-item">
          <div class="label-caps">Inspections</div>
          <app-unit-details-inspections></app-unit-details-inspections>
        </div>
        <div class="section-item">
          <app-unit-details-pictures-section
            [readOnly]="readOnly"
            [unitId]="unitId"
          ></app-unit-details-pictures-section>
        </div>
        <div class="section-item property-section">
          <div class="label-caps">Property information</div>
          <div class="section-item-content">
            <app-unit-details-property-section
              [readOnly]="readOnly"
              [descriptionGroup]="form"
            ></app-unit-details-property-section>
          </div>
        </div>
        <div class="section-item">
          <div class="label-caps">Rents</div>
          <div class="section-item-content">
            <app-unit-details-description-section
              [readOnly]="readOnly"
              [descriptionGroup]="form"
            ></app-unit-details-description-section>
          </div>
        </div>
      </form>
    </div>
  </app-dashboard-container>
</div>

<ng-template #customHeaderTemplate>
  <div class="unit-header">
    <div class="display-flex align-items-center">
      <!-- NOTE: commented temporary, do not delete -->
      <!-- <button mat-button color="primary" class="back-to-parent" (click)="backToParent()" (keydown.enter)="backToParent()">
      <div class="display-flex align-items-center justify-content-center grid-gap-8">
        <app-icon
          [iconColor]="EColorPalette.cGreen3"
          [iconHeight]="24"
          [iconWidth]="24"
          [svg]="EIcon.ARROW_LEFT"
        ></app-icon>
        <span>Back</span>
      </div>
    </button> -->
      <a [href]="previousRoute" (click)="goBack($event)" mat-button color="primary" class="back-to-parent">
        <div class="display-flex align-items-center justify-content-center grid-gap-8">
          <app-icon
            [iconHeight]="24"
            [iconWidth]="24"
            [iconColor]="EColorPalette.cGreen3"
            [svg]="EIcon.ARROW_LEFT"
          ></app-icon>
          <span>Back</span>
        </div>
      </a>
      <h3>{{ unit?.propertyName || '' }} - {{ unit?.name || '' }}</h3>

      <span class="text-color dark ml-8">{{ moveOutType | enumerationValue: moveOutTypeListConst:true }}</span>
    </div>
    <ng-container *ngIf="unit?.isNonPms">
      <button
        mat-stroked-button
        color="warn"
        class="extra-thin-button"
        (click)="deleteUnit()"
        [disabled]="deleteInProgress$ | async"
      >
        <div class="display-flex align-items-center grid-gap-8">
          <span class="delete-label">Delete unit</span>
          <mat-spinner *ngIf="deleteInProgress$ | async" color="accent" diameter="20"></mat-spinner>
        </div>
      </button>
    </ng-container>
  </div>
</ng-template>

<ng-template #unitEmptyDataTemplate>
  <app-empty-data
    [info]="'The selected unit does not exist, or there was an error retrieving it'"
    class="h-100"
  ></app-empty-data>
</ng-template>
